<template>
  <div class="full contain">
    <nav>
      <!-- <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link> -->
      <!-- <h1>验证你的设备</h1> -->
    </nav>
          <div class="region">
      <!-- <div class="full"> -->
      <div class="topBar">
        <div class="expendDiv">
        </div>

        <div class="languageSelect">
          <span
            @click="selectLang('en')"
            :class="language === 'en' ? 'active' : ''"
            >English</span
          >
          <span
            @click="selectLang('kr')"
            :class="language === 'kr' ? 'active' : ''"
            >한국어</span
          >
          <span
            @click="selectLang('ja')"
            :class="language === 'ja' ? 'active' : ''"
            >日本語</span
          >
          <span
            @click="selectLang('zh')"
            :class="language === 'zh' ? 'active' : ''"
            >简体中文</span
          >
          </div>
      </div>


        <div class="loginBackground">
          <!-- <div class="image" :class="useRegistBackground ? 'regist-bg': ''"></div> -->
          <div class="image" :class="$route.meta?.backgroundClass" ></div>
          
        </div>
          <div class="main">
            <div class="logo" :class="language == 'zh'? '': 'global'"></div>
             <div class="returnBtn" v-if="accountId">
                <el-button class="btn" circle @click="logout()">{{$t('login.logoutBtn')}}</el-button>
             </div>
            <router-view />   
            <div class="jingtengtech">{{$t('companyName')}}</div>
          </div>        
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import { appStore } from './stores/app';
import { userStore } from './stores/user';
import { mapState } from 'pinia';
// import { getToken } from '@/utils/auth'

const BASE_FONT_SIZE = 16;

export default {  
  
   data(){
    return {
      // hasToken: false
      useRegistBackground: false
    }
  },

  mounted(){
    // console.log(`main clientId: ${this.clientApp}`, this.$router.query);
    
    // this.hasToken = getToken();
    console.log('app main', this.$router, this.$route)
    
    this.resize();
  },

  computed: {
    ...mapState(appStore, ['language']),
    ...mapState(userStore, ['accountId'])
  },

  watch: {
    accountId: {
      handler: function (val, oldVal) {
  //       // 
  //       this.myRule = {
  //         username: [{ required: true, message: this.$t('login.inputUsername'), trigger: 'blur' }],
  //         password: [{ required: true, message: this.$t('login.inputPassword'), trigger: 'blur' }]
  //       }
      },
      deep: true
    }
  },

  methods: {

    selectLang(lang) {
      appStore().setLangurage(lang);
    },

    resize(){
      // const that = this;
      const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
     
    //  const isMobile = settings.isMobile;
    //  console.log('isMobile', isMobile)

     const pcStandardSize = {
       width: 1920,
       height: 1080
     }

     const mobileStandardSize = {
       width: 375,
       height: 812
     }

     const standardSize = isMobile ? mobileStandardSize : pcStandardSize;

      window.onresize = function temp() {
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        document.documentElement.style.fontSize = width / standardSize.width < height / standardSize.height ? 
          `${width / standardSize.width * BASE_FONT_SIZE}px` : `${height / standardSize.height * BASE_FONT_SIZE}px`;
      };
      window.onload = function temp() {        
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        document.documentElement.style.fontSize = width / standardSize.width < height / standardSize.height ? 
          `${width / standardSize.width * BASE_FONT_SIZE}px` : `${height / standardSize.height * BASE_FONT_SIZE}px`;
      };
    },

    
    logout() {
      // console.log('aaaa', appStore())
      userStore().logout();
      // this.$router.push({ 'path': `/${appStore().appRoute}` })
      // console.log('bbb')
      this.$router.push({ name: `login` });
      // this.$router.push({ name: 'RaMain' })
    }
  }


} 

</script>

<style lang="scss" >
body{
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-family: Source Han Sans CN, Source Han Sans CN;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.region{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 85rem;
  height: 47.5rem;  
  // box-shadow: 0rem 0.88rem 1.56rem 0.06rem rgba(73, 89, 102, 0.14000000059604645); 
  box-shadow: 0rem 0.88rem 1.56rem 0rem rgba(73,89,102,0.14);
  border-radius: 3.13rem;  
  // border: 1px solid pink;
  // margin: auto;
  display: flex;

  .loginBackground{
    width: 42.5rem;
    background: #285AC4; 
    border-radius: 3.13rem 0rem 0rem 3.13rem;  
    overflow: hidden;

    .image{
      width: 100%;
      height: 100%;  
      // background: url('~@/assets/login_bg.png') no-repeat center;
      background-image: url('~@/assets/login_bg.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;

      &.regist-bg{
        background: url('~@/assets/background-regist.svg') no-repeat center;
      }
    }
  }

  .main{
    width: 46.25rem;
    height: 47.5rem;
    border-radius: 0rem 2.5rem 2.5rem 0rem;
    background: #FFFFFF;
    position: relative;

    .logo{
      position: absolute;
      left: 2.06rem;
      top: 1.81rem;
      width: 9.19rem;
      height: 3.06rem;
      // background: url('~@/assets/logo_font.png') no-repeat center;
      background-image: url('~@/assets/logo_font.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      z-index: 10;

      &.global{
        background: url('~@/assets/logo_font_en.svg') no-repeat center;
        background-size: cover;
      }
    }

    .returnBtn{
      position: absolute;
      right: 2.06rem;
      top: 1.81rem;
      width: 9.19rem;
      height: 3.06rem;
      // background: url('~@/assets/logo_font.png') no-repeat center;
      background-size: contain;
      z-index: 10;

      
      .btn {
          min-width: 3.6rem;
          min-height: 3.6rem;
          border: 0px;          
          background-color:  #F5F5F5;
          color: #969696;
        }
    }

    .jingtengtech{
      position: absolute;
      left: 0;
      right:0;
      margin: auto;
      height: 0.63rem;
      font-size: 0.75rem;
      font-family: Microsoft YaHei UI-Regular, Microsoft YaHei UI;
      font-weight: 400;
      color: #A4A0A0;
      line-height: 0.63rem;
      bottom: 1.13rem;
      user-select: none;
      // border:1px solid pink;
    }
  }
}



.topBar{
  display: flex;
  position: absolute;
  top: -6.19rem;
  right: 0.2rem;
  // padding: 0 10rem;
  justify-content: right;
  // background-color: pink;

  .expendDiv{
    // flex: 1;
    // width: 1rem;
    // height: 10rem;
    flex-shrink: 1;
    flex-grow: 1;
    background-color: yellow;
  }
}


.languageSelect {
    flex-grow: 0;
    margin-top: 2rem;

    span {
      color: #A4A0A0;
      font-size: 1rem;
      transition: all 0.3s;
      cursor: pointer;
      margin-left: 1rem;
      padding: 0.5rem;
      // border: 1px solid #A4A0A0;
      // border-radius: 0.2rem;
      // background-color: rgba(255,255,255,0);
      
      background: #F1F2F7;
      border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
    }
    span:hover {
      color: #fff;
      background: #859DD4;
      border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
      // text-decoration: underline;
    }
    .active{
      color: #fff;
      // border: 1px solid #fff;
      // background-color: rgba(255,255,255,0.2);
      background: #859DD4;
      border-radius: 0.25rem 0.25rem 0.25rem 0.25rem;
    }
  }

  .el-icon{
    vertical-align: middle;
  }

  .el-form-item__content{
    user-select: none;
  }


  :root{
    --el-color-primary: #285AC4;
    --el-fill-color-blank: #F9FAFE;
    --el-border-radius-base: 4px;
    --el-input-border-radius: 4px;
  }
  // :deep .el-button{
  //   --el-button-bg-color: #285AC4
  // }
</style>

<style lang="scss" scoped>

.full{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: url('~@/assets/background.png') no-repeat center;
  background-size: cover;

  // &.contain{
  //   position: relative;
  // }
}

</style>
